import React, { useEffect } from 'react'
import ReactSelect, { Option } from 'react-select'

import i18n from 'live/services/i18n'

import { ListButtonsPagination, PaginationContainer, SelectLimitPagination } from './styles'
import { Scrollbars } from 'plugin-generic-components/shared/components/components'

interface IProps {
    total: number
    offset: number
    setOffset: (k: number) => void
    limit: ISelect
    setLimit: (k: ISelect) => void
    setPage?: (k: number) => void
}

interface ISelect {
    value: number
    label: string
}

export const SystemAuditPagination: React.FC<IProps> = ({ total, offset, setOffset, limit, setPage, setLimit }) => {
    const maxItems = 5
    const maxLeft = (maxItems - 1) / 2
    const current = offset ? offset / limit.value + 1 : 1
    const pages = Math.ceil(total / limit.value)
    const first = Math.max(current - maxLeft, 1)

    function onPageChange(page): void {
        setOffset((page - 1) * limit.value)
        setPage(page)
    }

    const limitOptions = [
        { label: `10 ${i18n('items')} | ${i18n('page')}`, value: 10 },
        { label: `20 ${i18n('items')} | ${i18n('page')}`, value: 20 },
        { label: `30 ${i18n('items')} | ${i18n('page')}`, value: 30 },
        { label: `40 ${i18n('items')} | ${i18n('page')}`, value: 40 },
        { label: `50 ${i18n('items')} | ${i18n('page')}`, value: 50 },
        { label: `100 ${i18n('items')} | ${i18n('page')}`, value: 100 }
    ]

    useEffect(() => {
        setOffset(0)
    }, [limit.value, setOffset, total])

    return (
        <PaginationContainer>
            <SelectLimitPagination>
                <ReactSelect
                    options={limitOptions}
                    onChange={(item: Option<number>) => {
                        setLimit(item)
                    }}
                    value={limit}
                    clearable={false}
                    id="systemAudit-systemAuditPagination-field-perPage"
                />
            </SelectLimitPagination>

            <ListButtonsPagination>
                <li>
                    <button
                        onClick={() => onPageChange(current - 1)}
                        disabled={current === 1}
                        id="systemAudit-systemAuditPagination-pagesLeft-button"
                    >
                        <i className="fas fa-chevron-left"></i>
                    </button>
                </li>
                {Array.from({ length: Math.min(maxItems, pages) })
                    .map((_, index) => index + first)
                    .map(page => {
                        if (page <= pages) {
                            return (
                                <li key={page}>
                                    <button
                                        className={page === current && 'active-page'}
                                        onClick={() => onPageChange(page)}
                                        id={`systemAudit-systemAuditPagination-page${page}-button`}
                                    >
                                        {page}
                                    </button>
                                </li>
                            )
                        }
                    })}
                {current <= pages - (maxLeft + 1) && pages > maxItems && (
                    <>
                        <div className="reticence">
                            <div className="circle"></div>
                            <div className="circle"></div>
                            <div className="circle"></div>
                        </div>
                        <li>
                            <button
                                onClick={() => onPageChange(pages)}
                                id="systemAudit-systemAuditPagination-reticence-button"
                            >
                                {pages}
                            </button>
                        </li>
                    </>
                )}
                <li>
                    <button
                        onClick={() => onPageChange(current + 1)}
                        disabled={current === pages}
                        id="systemAudit-systemAuditPagination-pagesRight-button"
                    >
                        <i className="fas fa-chevron-right"></i>
                    </button>
                </li>
            </ListButtonsPagination>
        </PaginationContainer>
    )
}
